/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import ProductService from "../../../../services/ProductService";
import MasterService from "../../../../services/MasterService";
import moment from "moment";
export const userData = localStorage.getItem("persist:root")
  ? JSON.parse(JSON.parse(localStorage.getItem("persist:root")).userData)
  : "";
import editicoSvg from "../../../../public/edit-product.svg";
import { showLoading } from "react-global-loading";

class ViewProducts extends React.Component {
  constructor(props) {
    super(props);
    const url = new URL(window.location);

    this.state = {
      filteredList: [],
      currentPage: url.searchParams.get("page")
        ? parseInt(url.searchParams.get("page"))
        : 1,
      statusCount: {},
      statusType: 1,
      categories: [],
      selectedCategory: "",
      countries: [],
      selectedCountry: "",
      searchQuery: "",
    };
  }

  componentDidMount = () => {
    this.getCategories();
    this.getAllCountries();
    // if (this.state.currentPage > 1) {

    //   for (let i = 1; i <= this.state.currentPage; i++) {
    //     this.getProductList(i, this.state.statusType);
    //   }
    // }
    // else this.getProductList(this.state.currentPage, this.state.statusType);
    this.filterdata();
  };

  getCategories = () => {
    showLoading(true);
    MasterService.getCategories()
      .then(result => {
        if (!result) {
          return;
        }
        this.setState({ categories: result });
        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  getProductList = query => {
    showLoading(true);
    ProductService.fetchAllProducts(query)
      .then(result => {
        if (!result?.data) {
          return;
        }
        this.setState({ filteredList: result.data, statusCount: result });
        // this.setState((prevState) => ({
        //   statusCount: result,
        //   filteredList: [...prevState.filteredList, ...result.data]
        // }));

        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };


  deleteProduct2 = async (id) => {
    // Confirm deletion
    const isConfirmed = window.confirm("Are you sure you want to delete this product?");

    if (!isConfirmed) {
      return; // Exit the function if deletion is not confirmed
    }

    const url = 'https://agpuat.digitalindiacorporation.in/agp/index.php/wp-json/wp/v2/agp_delete_post';

    const requestBody = {
      id: id,
      action: 'delete',
      type: 'products'
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Delete response:', data); // Log the response

      // Check if the message exists and is not empty
      if (data.message) {
        console.log('Message to show:', data.message);
        alert(data.message); // Display the alert

        // Re-fetch the product list to update the listing after deletion
        this.getProductList(this.state.query);
      } else {
        console.warn('No message in response data');
      }
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };



  getAllCountries = () => {
    MasterService.getAyushCountries()
      .then(result => {
        if (!result) {
          showLoading(false);
          return;
        }
        this.setState({ countries: result });
        showLoading(false);
      })
      .catch(err => {
        console.error(err);
        showLoading(false);
      });
  };

  pdfDownload = () => {
    const { statusType, filteredList } = this.state;
    MasterService.getPdf("Product", filteredList, statusType);
  };

  productType = (page, type) => {
    let filteredList = [], query = {};
    this.setState({ statusType: type });
    const url = new URL(window.location);
    url.searchParams.set("page", page);
    query.page = 1, query.status = type;
    window.history.pushState(null, "", url.toString());
    this.getProductList(query);
    this.setState({ filteredList });
  };

  addProduct = () => {
    this.props.history.push({ pathname: "/super/add-product" });
  };
  resetFilter = () => {
    const url = new URL(window.location);
    url.searchParams.delete("s");
    url.searchParams.delete("country");
    url.searchParams.delete("status");
    url.searchParams.delete("cat");
    this.setState({ selectedCategory: "" });
    this.setState({ selectedCountry: "" });
    window.location.reload();
  };

  onLoad = () => {
    this.setState({ currentPage: parseInt(this.state.currentPage) + 1 });

    const url = new URL(window.location);
    url.searchParams.set("page", this.state.currentPage + 1);
    window.history.pushState(null, "", url.toString());
    // this.setState({ query: { page: parseInt(this.state.currentPage) + 1 } })
    this.setState(prev => ({
      ...prev,
      query: {
        ...prev.query,
        ...{ page: parseInt(this.state.currentPage) + 1 },
      },
    }));
    ProductService.fetchAllProducts(this.state.query)
      .then(result => {
        if (!result.data) {
          return;
        }
        // this.setState({ filteredList: result.data })
        this.setState(prevState => ({
          statusCount: result,
          filteredList: [...prevState.filteredList, ...result.data],
        }));

        showLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  };

  onCategorySelected = (e) => {

    this.setState({ selectedCategory: e.target.value }, function () {
      this.filterdata()
    });
  }

  onCountrySelected = (e) => {
    this.setState({ selectedCountry: e.target.value }, function () {
      this.filterdata()
    });
  }

  filterdata = () => {
    const url = new URL(window.location);
    {
      this.state.selectedCategory
        ? url.searchParams.set("cat", this.state.selectedCategory)
        : url.searchParams.delete("cat");
    }
    {
      this.state.selectedCountry
        ? url.searchParams.set("country", this.state.selectedCountry)
        : url.searchParams.delete("country");
    }
    {
      this.state.statusType
        ? url.searchParams.set("status", this.state.statusType)
        : url.searchParams.delete("status");
    }
    {
      this.state.searchQuery
        ? url.searchParams.set("s", this.state.searchQuery)
        : url.searchParams.delete("s");
    }
    // { this.state.currentPage ? url.searchParams.set('page', this.state.currentPage) : url.searchParams.delete('page') }
    url.searchParams.delete("page");
    this.setState({ currentPage: 1 });
    let query = {};
    this.setState({ query });
    this.state.selectedCategory &&
      (query.category = this.state.selectedCategory);
    this.state.selectedCountry && (query.country = this.state.selectedCountry);
    this.state.statusType && (query.status = this.state.statusType);
    // this.state.currentPage && (query.page = this.state.currentPage);

    this.state.searchQuery && (query.s = this.state.searchQuery);
    this.getProductList(query);
    window.history.pushState(null, "", url.toString());
  };

  render() {
    const {
      filteredList,
      statusType,
      statusCount,
      categories,
      selectedCategory,
      selectedCountry,
      countries,
      query,
      searchQuery,
    } = this.state;
    let fullyLoaded;
    switch (statusType) {
      case 1: //all
        fullyLoaded = filteredList.length === statusCount.total ? true : false;
        break;
      case 2: //pending
        fullyLoaded =
          filteredList.length === statusCount.pending ? true : false;
        break;
      case 3: //approved
        fullyLoaded =
          filteredList.length === statusCount.approved ? true : false;
        break;
    }
    return (
      <>
        <div className="container-fluid productscontainer" id="main">
          <nav aria-label="breadcrumb">
            {/* <ol className="breadcrumb">
              <li className="breadcrumb-item"><Link to="#">Home</Link></li>
              <li className="breadcrumb-item active" aria-current="page">All</li>
            </ol> */}
          </nav>
          <hr></hr>
          <div className="row">
            <div className="col-md-8">
              <h3>
                <b>Products</b>
              </h3>
            </div>
            <div className="col-md-4 btr">
              {/* <button className="btn btndbg" onClick={() => this.pdfDownload()}>
                Export
              </button>{" "} */}
              <button className="btn theme-btn-fill btndbg" onClick={() => this.addProduct()}>
                Add Product
              </button>
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <ul className="nav nav-tabs admintabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    onClick={e => this.productType(1, 1)}
                    data-bs-toggle="tab"
                    type="button"
                    role="tab"
                    aria-selected="true"
                  >
                    View
                    <span className="badge text-bg-secondary rounded-circle p-2 ms-2">
                      {statusCount.total}
                    </span>
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    data-bs-toggle="tab"
                    type="button"
                    role="tab"
                    onClick={e => this.productType(1, 3)}
                    aria-controls="approval-pending-products-pane"
                    aria-selected="false"
                  >

                    Approved
                    <span className="badge text-bg-secondary rounded-circle p-2 ms-2">
                      {statusCount.approved}
                    </span>
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    data-bs-toggle="tab"
                    type="button"
                    role="tab"
                    onClick={e => this.productType(1, 2)}
                    aria-controls="approval-pending-products-pane"
                    aria-selected="false"
                  >

                    Pending
                    <span className="badge text-bg-secondary rounded-circle p-2 ms-2">
                      {statusCount.pending}
                    </span>
                  </button>
                </li>
              </ul>
              <div className="tab-content bg-white p-3 mt-4" id="myTabContent">
                {/* productList start */}
                <div
                  className="tab-pane fade show active"
                  id="view-all-products-pane"
                  role="tabpanel"
                  aria-labelledby="#view-all-products"
                >
                  <div className="row pnkbg p-3 mt-3 rounded rounded-2">
                    <div className="col-12">
                      <div className="row">
                        <span className="text-secondary d-block mb-2">
                          <i className="fa fa-filter" aria-hidden="true" />
                          Filter Products
                        </span>
                        <div className="col">
                          <div className="form-group position-relative has-search">
                            <span className="fa fa-search form-search"></span>
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              name="productname"
                              placeholder="Search By Name"
                              onChange={e =>
                                this.setState({ searchQuery: e.target.value })
                              }
                              onKeyDown={e =>
                                e.key === "Enter" && this.filterdata()}
                              value={searchQuery}
                            />
                          </div>
                        </div>

                        <div className="col">
                          <div className="form-group position-relative">
                            <select
                              name="orderby"
                              className="form-select form-select-lg"
                              aria-label="Shop order"
                              value={selectedCategory}
                              onChange={e =>
                                this.onCategorySelected(e)
                              }
                            >
                              <option value="" defaultValue="selected">
                                Categories
                              </option>
                              {categories.map((item, index) => (
                                <option key={index} value={item.name}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-group position-relative">
                            <select
                              className="form-select form-select-lg"
                              aria-label="select Country"
                              value={selectedCountry}
                              onChange={e =>
                                // this.setState({
                                //   selectedCountry: e.target.value,
                                // })
                                this.onCountrySelected(e)
                              }
                            >
                              <option value="" defaultValue="selected">
                                Countries
                              </option>
                              {countries.map((item, index) => (
                                <option key={index} value={item.id}>
                                  {item.blogname}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        {/* <div className="col-md-1 hdblk text-end">
                          <div className="usersearchbtn">

                            <button
                              type="button"
                              className="btn btndbg border-0 rounded-0 p-2"
                              onClick={() => this.filterdata()}
                            >
                              Search
                            </button>
                          </div>
                        </div> */}
                        <div className="col-md-1 hdblk text-end">
                          <div className="usersearchbtn">

                            <button
                              type="button"
                              className="btn theme-btn-fill btndbg border-0 rounded-0 p-2"
                              onClick={() => this.resetFilter()}
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="#view-all-products"
                    className="row bg-light p-3 mt-3 rounded rounded-2"
                  >
                    <div className="col-12">
                      <div className="row view-group" id="products">
                        {filteredList.length > 0 ? (
                          filteredList.map((item, index) => (
                            <div
                              key={index}
                              className="col-xxl-3 col-lg-4 col-md-2 col-sm-6 mb-3"
                            >
                              <div className="card p-3 event-card crdev">
                                <Link
                                  to={{
                                    pathname: "/super/products-detail",
                                    search: `?id=${item.ID}`,
                                    state: { productDetails: item },
                                  }}
                                >
                                  <div className="imgrel position-relative">
                                    <img
                                      src={
                                        item?.product_image[0] ||
                                        require("../../../../public/packet.png")
                                      }
                                      className="img-fluid card-img-top rounded"
                                      alt="events"
                                    // style={{
                                    //   height: "150px",
                                    //   objectFit: "cover",
                                    // }}
                                    />

                                    {/* <div className="card-img-overlay pazre">
                                    <Link
                                      to={{
                                        pathname:
                                          statusType === 2
                                            ? "/super/update-product-status"
                                            : "/super/update-product",
                                        search: `?id=${item.ID}`,
                                        state: { productDetails: item },
                                      }}
                                      className="btn d-block"
                                    >
                                      <img
                                        src={editicoSvg}
                                        alt="edit product"
                                      />
                                    </Link>
                                  </div> */}
                                    <div className="position-absolute bottom-0 end-0 me-2 mb-2">
                                      <div className="d-flex flex-column gap-2">
                                        <Link
                                          to={{
                                            pathname:
                                              statusType === 2
                                                ? "/super/update-product-status"
                                                : "/super/update-product",
                                            search: `?id=${item.ID}`,
                                            state: { productDetails: item },
                                          }}
                                          className="text-dark"
                                        >
                                          <i class="fa fa-pencil-square" aria-hidden="true"></i></Link>
                                        <i className="fa fa-trash" onClick={() => this.deleteProduct2(item.ID)} aria-hidden="true"></i>
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                                <div className="evtxcn px-0 ">
                                  <h4 className="evh">
                                    <span className="crop-text evhd">
                                      {item.post_title}
                                    </span>
                                  </h4>
                                  <div className="d-flex">
                                    <span className="crop-text muted d-block mt-1 doccell me-3">
                                      {item.post_title}
                                    </span>
                                    {/* <span className="crop-text muted d-block mt-1 doccell bg-danger text-white" onClick={() => this.deleteProduct2(item.ID)}>
                                      Delete
                                    </span> */}
                                  </div>


                                  <div className="evdes_nw text-truncate">
                                    {item.post_content}
                                  </div>
                                </div>
                              </div>
                              <div
                                className={
                                  item.post_status === "pending"
                                    ? "crbotm_red"
                                    : "crbotm"
                                }
                              >
                                <p className="dtpr">
                                  Created -
                                  <span className="cdte">
                                    {moment(item.post_date).format(
                                      "Do MMM YYYY",
                                    )}
                                  </span>
                                </p>
                                <span className="dtpr">|</span>
                                <p className="dtpr">
                                  {` Updated - `}
                                  <span className="cdte">
                                    {moment(item.post_modified).format(
                                      "Do MMM YYYY",
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <span>No Product Found</span>
                          </div>
                        )}
                        {filteredList.length > 0 ? (
                          fullyLoaded ? (
                            <span> </span>
                          ) : (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                style={{
                                  backgroundColor: "#beeadc",
                                  border: "none",
                                  borderRadius: "10px",
                                  padding: "10px 2rem",
                                  fontWeight: "semibold",
                                }}
                                onClick={e => this.onLoad()}
                              >
                                Load More
                              </button>
                            </div>
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default ViewProducts;
